/** Settings Format dropdown value for the carrier-label default. Not a PAPI doc type. */
export function shippingLabelFormatFromZplDefault(value) {
    return value === true ? "zpl" : "pdf";
}

/** True only for the lowercase format token "zpl". Modal values like "Zpl" stay false. */
export function zplDefaultFromShippingLabelFormat(format) {
    return String(format == null ? "" : format).trim().toLowerCase() === "zpl";
}
